// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { attributesStyles } from "@tps/Overrides/Widgets/ProductDetails/ProductDetailsAttributes";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

attributesStyles.wrapper = {
    css: css``,
};

attributesStyles.dataTableRow = {
    css: css`
        &:nth-child(even) {
            background-color: ${color("common.ui1")};
        }
        &:nth-child(odd) {
            background-color: ${color("common.ui5")};
        }
    `,
};

attributesStyles.dataTableHeadCell = {
    typographyProps: {
        size: 12,
        weight: "bold",
        color: "common.ui1",
        css: css`
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
    css: css`
        line-height: 17px;
        padding: 4px 12px;
    `,
};

attributesStyles.dataTableCell = {
    typographyProps: {
        size: 14,
        css: css`
            letter-spacing: 0;
            line-height: 19px;
        `,
    },
    css: css`
        font-size: 14px;
        line-height: 17px;
        padding: 7px 12px;
    `,
};
